import React from 'react';

// Dynamics BPO mark rebuilt as vector graphics — crisp at any size
export default function Logo({ size = 34 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" aria-label="Dynamics logo">
      <defs>
        <linearGradient id="dyn-cyan" x1="0" y1="0" x2="1" y2="0.3">
          <stop offset="0" stopColor="#00E8FF" />
          <stop offset="1" stopColor="#0047FF" />
        </linearGradient>
        <linearGradient id="dyn-orange" x1="0.2" y1="0" x2="0.9" y2="1">
          <stop offset="0" stopColor="#E8401C" />
          <stop offset="0.35" stopColor="#FFA000" />
          <stop offset="1" stopColor="#F4511E" />
        </linearGradient>
        <mask id="dyn-crescent">
          <rect width="100" height="100" fill="white" />
          <circle cx="30" cy="50" r="37" fill="black" />
        </mask>
      </defs>

      {/* cyan chevron */}
      <polygon
        points="12,12 32,12 58,50 32,88 12,88 38,50"
        fill="url(#dyn-cyan)"
      />

      {/* orange crescent wrapping the right side */}
      <circle cx="55" cy="50" r="41" fill="url(#dyn-orange)" mask="url(#dyn-crescent)" />
    </svg>
  );
}
